import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageSFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 14.67C14.4601 14.67 16.6401 15.44 18.1301 16.63V18.82C18.1301 20.02 17.1601 20.99 15.9601 20.99H8.05012C6.85012 20.99 5.88012 20.02 5.88012 18.82V16.63C7.37012 15.44 9.55012 14.67 12.0101 14.67H12.0001ZM18.1301 12.5V15.18C16.4801 14.12 14.3301 13.49 12.0001 13.49C9.67012 13.49 7.53012 14.12 5.87012 15.18V12.5C5.87012 10.19 7.15012 8.18 9.03012 7.14V6.97C9.03012 5.33 10.3601 4 11.9901 4C13.6201 4 14.9501 5.33 14.9501 6.97V7.14C16.8401 8.18 18.1101 10.19 18.1101 12.5H18.1301ZM10.2601 6.62C10.8101 6.46 11.4001 6.36 12.0101 6.36C12.6201 6.36 13.2001 6.45 13.7501 6.62C13.5901 5.8 12.8701 5.18 12.0101 5.18C11.1501 5.18 10.4201 5.8 10.2701 6.62H10.2601ZM13.5801 10.32H10.4201V11.51H13.5801V10.32Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageSFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageSFilledIcon;
